import React, { useState, useEffect } from "react";
import { Route, Redirect, useLocation } from "react-router-dom";
import Layout from "./Layout/layout";
import { connect } from "react-redux";
import { setUser } from "./redux/actions/AuthActions";
import Splash from "./screens/splash/splash";
import { requestForToken, onMessageListener } from "./firebase";
import { notification } from "antd";
import {getNotifications,getUnreadNotificationsCount} from './redux/actions/NotificationAction'

const App = ({ component: Component, rest, currentUser, isRTL, menu }) => {
  const [showSplash, setShowSplash] = useState(true);
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/Login") {
      setShowSplash(false);
      return;
    }

    const timer = setTimeout(() => {
      setShowSplash(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  // ✅ تسجيل الـ Service Worker + طلب التوكن بعد تسجيل الدخول
  useEffect(() => {
    if (currentUser) {
      if ("serviceWorker" in navigator) {
        navigator.serviceWorker
          .register("/firebase-messaging-sw.js")
          .then((registration) => {
            console.log("Service Worker registered with scope:", registration.scope);

            // أول ما يتسجل الـ SW اطلب التوكن
            requestForToken(currentUser.token, isRTL);
          })
          .catch((err) => {
            console.error("Service Worker registration failed:", err);
          });
      }
    }
  }, [currentUser, isRTL]);

   // ✅ (Notification UI)
  useEffect(() => {
    onMessageListener()
      .then((payload) => {
        console.log("Foreground Message:", payload);
        notification.open({
          message: payload?.notification?.title || "New Notification",
          description: payload?.notification?.body || "You have a new update.",
          placement: "topRight",
          duration: 50000, 
        });
        getNotifications(1,true,currentUser.token)
        getUnreadNotificationsCount(currentUser.token)
      })
      .catch((err) => console.log("FCM Error: ", err));
  }, []);

  if (showSplash) {
    return <Splash />;
  }

  let marginLeft, marginRight;
  if(menu === true){
    marginLeft=80
    /*if(isRTL){
      marginLeft='auto'
      marginRight=80
    }else{
      marginLeft=80
      marginRight='auto'
    }*/
    
  }else{
    marginLeft=200
    /*if(isRTL){
      marginLeft='auto'
      marginRight=200
    }else{
      marginLeft=200
      marginRight='auto'
    }*/
  }

  if (currentUser == null) return <Redirect to="/Login" />;
  let userData = localStorage.getItem("@USER-BYIT-ADMIN");
  if (!userData) return <Redirect to="/Login" />;

  return (
    <Route
      {...rest}
      render={(routeProps) => (
        <Layout marginLeft={marginLeft} marginRight={marginRight} collapsed={menu}>
          <Component {...routeProps} />
        </Layout>
      )}
    />
  );
};

const mapToStateProps = (state) => ({
  currentUser: state.auth.currentUser,
  isRTL: state.lang.isRTL,
  menu: state.menu.menu,
  getNotifications,
  getUnreadNotificationsCount,
});

const mapDispatchToProps = {
  setUser,
};

export default connect(mapToStateProps, mapDispatchToProps)(App);

